import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      choosenTimezone: 'timezone/choosenTimezone',
      user: 'auth/user',
    }),
  },

  methods: {
    convertBookedSlotToBePrintedOnDashboard(slot, userType) {
      const startDate = this.convertDateInChoosenTimezone(slot.start_date);
      const endDate = this.convertDateInChoosenTimezone(slot.end_date);
      let startMinutes = startDate.minute().toString();
      if (startMinutes === '0') startMinutes = '00';
      let endMinutes = endDate.minute().toString();
      if (endMinutes === '0') endMinutes = '00';
      let newSlot;
      if (userType === 'teacher') {
        newSlot = {
          day: `${startDate.date()}/${startDate.month() + 1}/${startDate.year()}`,
          timeStart: `${startDate.hour()}:${startMinutes}`,
          timeEnd: `${endDate.hour()}:${endMinutes}`,
          startDate,
          id: slot.id,
          student_name: slot.student.name,
          user_id: slot.student.user_id,
          user_type: slot.student.user_type,
          booking_id: slot.booking_id,
          ready: false,
        };
      }
      if (userType === 'student') {
        newSlot = {
          day: `${startDate.date()}/${startDate.month() + 1}/${startDate.year()}`,
          timeStart: `${startDate.hour()}:${startMinutes}`,
          timeEnd: `${endDate.hour()}:${endMinutes}`,
          startDate,
          id: slot.id,
          teacher_name: slot.teacher.name,
          teacher_id: slot.teacher.id,
          booking_id: slot.booking_id,
          ready: false,
        };
      }
      return newSlot;
    },

    checkSlotsTimeToMakeButtonAppear(array) {
      const slots = array;
      slots.forEach((slot) => {
        const newSlot = slot;
        const now = dayjs();
        const { startDate } = slot;
        startDate.subtract(15, 'm');
        if (now >= startDate) {
          startDate.add(30, 'm');
          if (now <= startDate) {
            newSlot.ready = true;
          } else {
            // qui bisognerà fare un controllo se la lezione è stata seguita o no
            // per ora le lezioni passate vengono rimosse dall'array
            const n = slots.findIndex((currentSlot) => currentSlot.startDate === newSlot.startDate);
            slots.splice(n, 1);
          }
        }
      });
      slots.sort((slotA, slotB) => (slotA.startDate > slotB.startDate));
      return slots;
    },

    convertSlotForCalendar(slot, timeFrom, timeTo) {
      const now = dayjs().tz(this.choosenTimezone);
      const start = this.convertDateInChoosenTimezone(slot.start_date);
      const end = this.convertDateInChoosenTimezone(slot.end_date);
      let newTimeFrom = timeFrom / 60;
      let newTimeTo = timeTo / 60;

      let newStatus = slot.status;
      if (start <= now) newStatus = 'past';
      if (start.hour() <= newTimeFrom) {
        newTimeFrom = start.hour() - 1;
      }
      if (end.hour() >= newTimeTo - 1) {
        newTimeTo = end.hour() + 2;
      }
      let newEvent = {};

      if (!slot.is_lunch_break) {
        newEvent = {
          start: this.changeDateFormatForCalendarAndDatabase(start),
          end: this.changeDateFormatForCalendarAndDatabase(end),
          class: newStatus,
          id: slot.id,
        };
      } else {
        newEvent = {
          start: this.changeDateFormatForCalendarAndDatabase(start),
          end: this.changeDateFormatForCalendarAndDatabase(end),
          class: 'lunch',
          title: this.$t('slotsCreation.lunch'),
          id: slot.id,
          background: true,
        };
      }

      const returnArray = {
        event: newEvent,
        timeFrom: newTimeFrom,
        timeTo: newTimeTo,
      };

      return returnArray;
    },

    convertMasterclassForCalendar(masterclass, timeFrom, timeTo) {
      const now = dayjs().tz(this.choosenTimezone);
      const start = this.convertDateInChoosenTimezone(`${masterclass.day} ${masterclass.start}`);
      const end = this.convertDateInChoosenTimezone(`${masterclass.day} ${masterclass.end}`);
      let newTimeFrom = timeFrom / 60;
      let newTimeTo = timeTo / 60;

      let newStatus = 'masterclass';
      if (start <= now) newStatus = 'past';
      if (start.hour() <= newTimeFrom) {
        newTimeFrom = start.hour() - 1;
      }
      if (end.hour() >= newTimeTo - 1) {
        newTimeTo = end.hour() + 2;
      }
      let newEvent = {};

      newEvent = {
        title: masterclass.title.toUpperCase(),
        start: this.changeDateFormatForCalendarAndDatabase(start),
        end: this.changeDateFormatForCalendarAndDatabase(end),
        class: newStatus,
        id: `masterclass_${masterclass.id}`,
      };

      const returnArray = {
        event: newEvent,
        timeFrom: newTimeFrom,
        timeTo: newTimeTo,
      };

      return returnArray;
    },

    separateDayAndTime(slotToConvert) {
      const editedSlot = {};
      const day = slotToConvert.start.toISOString().split('T')[0];
      editedSlot.day = day;

      const startTime = slotToConvert.start;
      let startHour = startTime.getHours();
      if (startHour < 10) startHour = `0${startHour}`;
      let startMinutes = startTime.getMinutes();
      if (startMinutes < 10) startMinutes = `0${startMinutes}`;

      const endTime = slotToConvert.end;
      let endHour = endTime.getHours();
      if (endHour < 10) endHour = `0${endHour}`;
      let endMinutes = endTime.getMinutes();
      if (endMinutes < 10) endMinutes = `0${endMinutes}`;

      editedSlot.start = `${startHour}:${startMinutes}`;
      editedSlot.end = `${endHour}:${endMinutes}`;

      return editedSlot;
    },

    separateDayAndTimeFromStringDate(slotToConvert) {
      const editedSlot = {};
      const day = slotToConvert.start.split(' ')[0];
      editedSlot.day = day;

      const startTime = slotToConvert.start.split(' ')[1];
      const startHours = startTime.split(':')[0];
      let startMinutes = startTime.split(':')[1];
      if (startMinutes === '0') {
        startMinutes = `0${startMinutes}`;
      }
      editedSlot.start = `${startHours}:${startMinutes}`;

      const endTime = slotToConvert.end.split(' ')[1];
      const endHours = endTime.split(':')[0];
      let endMinutes = endTime.split(':')[1];
      if (endMinutes === '0') {
        endMinutes = `0${endMinutes}`;
      }
      editedSlot.end = `${endHours}:${endMinutes}`;

      return editedSlot;
    },

    changeDateFormatForCalendarAndDatabase(date) {
      return `${date.year()}-${date.month() + 1}-${date.date()} ${date.hour() === 0 ? '00' : date.hour()}:${date.minute() === 0 ? '00' : date.minute()}:00`;
    },

    convertDateTimezoneForDatabase(date) {
      return dayjs.utc(date);
    },

    convertDateInChoosenTimezone(date) {
      const dateUTC = dayjs.tz(date, 'UTC');
      return dayjs(dateUTC).tz(this.choosenTimezone);
    },

    checkSlot(newSlot, savedSlots) {
      let ok = true;
      const newStartDate = dayjs(newSlot.start_date);
      const newEndDate = dayjs(newSlot.end_date);

      savedSlots.forEach((slot) => {
        if (slot.id !== newSlot.id) {
          const startDate = dayjs(slot.start_date);
          const endDate = dayjs(slot.end_date);

          if (newStartDate >= startDate && newStartDate <= endDate) ok = false;
          if (newStartDate === startDate && newEndDate === endDate) ok = false;
          if (newEndDate >= startDate && newEndDate <= endDate) ok = false;
        }
      });
      return ok;
    },

  },
};
